export enum SuggestType {
  HYBRID = "hybrid",
  SUGGEST = "suggest",
  TRENDING_QUERY = "trendingQuery",
  CLOSED = "closed"
}
